import { Box, Dialog, DialogTitle, Divider, Typography } from "@material-ui/core";
import { BedDoubleIcon } from "lucide-react";
import { observer } from "mobx-react-lite";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useCallback } from "react";
import useDialog from "../../../hooks/useDialog";
import RoomForm from "../forms/RoomForm";

const CreateRoomDialog = observer(function CreateRoomDialog({
  open,
  setOpen,
  redirectPath = "/rooms",
  backPage,
  backPath,
  propertyId,
  onSuccess,
  onSubmit,
}) {
  const { t } = useTranslation("common");
  const router = useRouter();

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleSuccess = useCallback(
    async (data) => {
      handleClose();
      if (onSuccess) {
        return onSuccess(data);
      }
      if (Array.isArray(data) && data.length > 0) {
        await router.push(redirectPath || "/rooms");
      } else if (data?._id && backPage && backPath) {
        await router.push(`/rooms/${data?._id}/${encodeURI(backPage)}/${encodeURIComponent(backPath)}`);
      } else {
        await router.push(redirectPath || "/rooms");
      }
    },
    [handleClose, onSuccess, backPage, backPath, router, redirectPath],
  );

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={open}
      onClose={handleClose}
      aria-labelledby="create-room-dialog"
      PaperProps={{
        className: "shepherd-newRoomDialog",
        style: { maxHeight: "calc(100vh - 96px)" },
      }}
    >
      <DialogTitle disableTypography>
        <Box display="flex" alignItems="center">
          <Box color="primary.main" display="flex" mr={1}>
            <BedDoubleIcon />
          </Box>
          <Typography variant="h6" className="shepherd-newRoomDialog-title">
            {t("Add room")}
          </Typography>
        </Box>
      </DialogTitle>
      <Divider />
      <RoomForm isDialog propertyId={propertyId} onCancel={handleClose} onSuccess={handleSuccess} onSubmit={onSubmit} />
    </Dialog>
  );
});

export { CreateRoomDialog };

export default function useCreateRoomDialog(dialogProps) {
  return useDialog((props) => <CreateRoomDialog {...props} {...dialogProps} />);
}
